// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";
import "toastify-js/src/toastify.css"
import initNavbar from "./navbar";
initNavbar()
